import { render, staticRenderFns } from "./outbound-fax-failed-icon.vue?vue&type=template&id=b289042e"
import script from "./outbound-fax-failed-icon.vue?vue&type=script&lang=js"
export * from "./outbound-fax-failed-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports